module.exports = __webpack_public_path__ + "static/img/gzq.c7c5bb06.png";